export default __webpack_public_path__ + "static/media/auth-bg.45bff334.png";